// ************
// Recipe Single View
// Recipe Image Component
// ************
import { MediaItem } from "@/components/Global/MediaItem/MediaItem";
import { ImageType, RecipeType } from "@/types/baseTypes";
import React from "react";
import styles from "./RecipeImage.module.scss";

interface RecipeImageProps {
  recipeDetails: RecipeType;
}

export function generateRecipeImages(recipeDetails: RecipeType) {
  const { bild_alttext, bild_desktop, bild_mobile, bild_tablet, bild_titel } =
    recipeDetails;
  // Sizes are 4:3 with maximum card sizes in mind
  const desktop_width = 1200;
  const desktop_height = 900;
  const tablet_width = 800;
  const tablet_height = 600;
  const mobile_width = 600;
  const mobile_height = 450;
  function generateImageObject(
    url: string,
    width: number,
    height: number,
  ): ImageType {
    return {
      url,
      width,
      height,
      alt: bild_alttext || "",
      title: bild_titel || "",
      mime_type: "image/webp", // Assuming JPEG, adjust if necessary
      image_blur: "", // Placeholder for blur data if needed
      link: url, // Assuming the image is linked to itself
      filename: url.split("/").pop() || "",
      name: bild_titel || "",
      acf: {
        link_1: "",
        link_2: "",
        text_1: "",
        text_2: "",
      },
      description: "",
      id: "0",
    };
  }
  const image_desktop: ImageType = generateImageObject(
    bild_desktop,
    desktop_width,
    desktop_height,
  );
  const image_tablet: ImageType = generateImageObject(
    bild_tablet,
    tablet_width,
    tablet_height,
  );
  const image_mobile: ImageType = generateImageObject(
    bild_mobile,
    mobile_width,
    mobile_height,
  );
  return {
    image_desktop,
    image_tablet,
    image_mobile,
  };
}

function RecipeImage({ recipeDetails }: RecipeImageProps) {
  const { image_desktop, image_tablet, image_mobile } =
    generateRecipeImages(recipeDetails);
  return (
    <section className={`${styles["recipe-image"]}`}>
      <MediaItem
        image_desktop={image_desktop}
        image_tablet={image_tablet}
        image_mobile={image_mobile}
        sizes="(max-width: 1023px) 95vw, 45vw"
      />
    </section>
  );
}

export default RecipeImage;
